// src/pages/UserDetailsForm.jsx
import React, { useState } from 'react';

const UserDetailsForm = ({ onStart, initialDetails, onNavigate }) => {
  const [name, setName] = useState(initialDetails?.name || '');
  const [birthDate, setBirthDate] = useState(initialDetails?.birthDate || '');
  const [question, setQuestion] = useState('');
  const [errors, setErrors] = useState({});

  const handleDateChange = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 2) value = `${value.slice(0, 2)}/${value.slice(2)}`;
    if (value.length > 5) value = `${value.slice(0, 5)}/${value.slice(5, 9)}`;
    setBirthDate(value.slice(0, 10));
  };

  const validate = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = 'Tu nombre es necesario para personalizar la lectura.';
    if (birthDate.trim().length !== 10) newErrors.birthDate = 'Ingresa tu fecha completa (DD/MM/AAAA).';
    if (!question.trim()) newErrors.question = 'Formula una pregunta para enfocar la energía.';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      onStart({ name, birthDate, question });
    }
  };

  const questionSuggestions = [
    '¿Qué energía debo cultivar en este momento?',
    '¿Qué me impide avanzar en el amor?',
    '¿Qué camino debo seguir en mi carrera?',
    '¿Cómo puedo mejorar mi bienestar?',
  ];

  return (
    <div className="page-container">
      <div className="form-page-header">
        <div className="form-page-icon">🌙</div>
        <h1 className="page-title font-cinzel">Antes de Comenzar</h1>
        <p className="page-subtitle">
          El tarot es un diálogo con tu alma. Tus datos personalizan la lectura y tu pregunta enfoca la energía del universo.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="user-details-form" noValidate>
        <div className="form-field">
          <label className="form-label">Tu nombre completo</label>
          <input
            type="text"
            placeholder="Ej: María García"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className={`main-input ${errors.name ? 'input-error' : ''}`}
            autoComplete="name"
          />
          {errors.name && <span className="field-error">{errors.name}</span>}
        </div>

        <div className="form-field">
          <label className="form-label">Fecha de nacimiento</label>
          <input
            type="text"
            placeholder="DD/MM/AAAA"
            value={birthDate}
            onChange={handleDateChange}
            className={`main-input ${errors.birthDate ? 'input-error' : ''}`}
            inputMode="numeric"
          />
          {errors.birthDate && <span className="field-error">{errors.birthDate}</span>}
        </div>

        <div className="form-field">
          <label className="form-label">Tu pregunta al oráculo</label>
          <textarea
            placeholder="¿Qué pregunta llevas en el corazón hoy?"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            className={`main-input main-textarea ${errors.question ? 'input-error' : ''}`}
            rows="3"
          />
          {errors.question && <span className="field-error">{errors.question}</span>}

          <div className="question-suggestions">
            <p className="suggestions-label">Sugerencias:</p>
            <div className="suggestions-grid">
              {questionSuggestions.map((s, i) => (
                <button
                  key={i}
                  type="button"
                  className="suggestion-chip"
                  onClick={() => setQuestion(s)}
                >
                  {s}
                </button>
              ))}
            </div>
          </div>
        </div>

        <button type="submit" className="main-button primary-button form-submit-btn">
          ✨ Iniciar mi Lectura
        </button>

        {onNavigate && (
          <button
            type="button"
            className="legal-inline-link"
            onClick={() => onNavigate('legal')}
          >
            Términos y Privacidad
          </button>
        )}
      </form>

      <div className="privacy-notice">
        <span className="privacy-icon">🔒</span>
        <p><strong>Tu privacidad es sagrada:</strong> Tus datos se guardan en este dispositivo. Solo se envían a un servidor seguro si creás un código de recuperación para acceder a tus compras y lecturas desde otro dispositivo.</p>
      </div>
    </div>
  );
};

export default UserDetailsForm;
